import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { headerStyles } from '../Styles/commonStyles';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import clsx from 'clsx';
import { ReactSVG } from 'react-svg';
import Images from '../Theme/Images';
import CloseIcon from '@material-ui/icons/Close';
import MinimizeIcon from '@material-ui/icons/Minimize';
import CloseChatWarning from '../Components/Queries/Chat/CloseChatWarning';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

@inject('commonStore', 'userStore', 'chatStore')
@observer
class Header extends Component {
    state = {
        showChatDialog: false
    }

    openPreferences = () => {
        this.props.history.push({
            pathname: '/preferences'
        })
    }

    goBack = () => {
        this.props.userStore.setProgress(false)
        const { goBackTo } = this.props.commonStore;
        if (this.props.location.pathname.toLowerCase().includes('chat') && !this.props.location.pathname.toLowerCase().includes('chats')) {
            this.setState({ showChatDialog: false })
            this.props.history.push({
                pathname: '/home',
            })
        }
        else {
            window.localStorage.removeItem("sessionId");
            this.props.chatStore.resetSessionId()
            if (goBackTo === 'home')
                this.props.history.push({
                    pathname: '/home',
                })
            else if (goBackTo === 'pendingQueries') {
                this.props.history.push({
                    pathname: '/queries/pending',
                })
                this.props.commonStore.setGoBackTo('home')
            }

            else if (goBackTo === 'preferences')
                this.props.history.push({
                    pathname: '/preferences',
                })
            else if (goBackTo === 'chatList')
                this.props.history.push({
                    pathname: '/chats',
                })
            else
                this.props.history.go(-1)
        }
    }

    componentDidMount() {
        this.props.commonStore.setActiveHeader(this.props.headerText)
    }

    renderMinimiseAndClose = () => {
        const { classes } = this.props;
        const { showSearchOnly } = this.props.commonStore
        return (
            <div className="rowFlex">
                {!showSearchOnly ? <div className={classes.minimize} onClick={(e) => this.showOnlyTextBox()}>&mdash;</div> : null}
            </div>
        )
    }



    showOnlyTextBox = () => {
        if (this.props.location.pathname.includes('home'))
            this.props.commonStore.showOnlyTextBox(true)
        else if (this.props.location.pathname.includes('chat'))
            this.props.commonStore.showOnlyTextBox(true)
        else {
            this.props.history.push('/home')
            this.props.commonStore.showOnlyTextBox(true)
        }
    }

    renderHomeHeader = () => {
        const { classes } = this.props;
        return (


            <div className={classes.hContainer}>
                <div className={clsx({ [classes.normalHeader]: true })}  >
                    <div className={clsx({ [classes.headerContainer]: true })} >
                        <div className={classes.logoContainer}>
                            <ReactSVG className={classes.logo} src={Images.logo} />
                            {/*this.renderMinimiseAndClose()*/}
                            {/*<ReactSVG src={Images.me} className={classes.profile} onClick={(event) => this.openPreferences()} />*/}
                        </div>
                        {/*!showSearchOnly ? this.renderMinimiseAndClose() : null*/}
                    </div>
                </div>
            </div>


        )
    }

    closeDialog = () => {
        this.setState({
            showChatDialog: false
        })
    }

    confirmCloseChat = () => {
        const { goBackTo } = this.props.commonStore;
        this.setState({
            showChatDialog: false
        })

        window.localStorage.removeItem("sessionId");
        this.props.userStore.resetAnonymousId()
        // if (!this.props.userStore.authenticated)
        //   this.props.userStore.setToken(undefined)
        this.props.chatStore.resetSessionId()
        if (goBackTo === 'home')
            this.props.history.push({
                pathname: '/home',
            })
        else if (goBackTo === 'pendingQueries')
            this.props.history.push({
                pathname: '/queries/pending',
            })
        else if (goBackTo === 'preferences')
            this.props.history.push({
                pathname: '/preferences',
            })
        else
            this.props.history.go(-1)
    }

    confirmClearChat = () => {
        this.setState({
            showChatDialog: false
        })
    }

    renderCommonHeader = () => {
        const { headerText, classes, theme } = this.props;
        const { customHeaderText, showSearchOnly } = this.props.commonStore
        return (
            <div className={classes.hContainer}>
                <div className={clsx({ [classes.normalHeader]: true, [classes.preferenceHeader]: headerText === 'Preferences' })}  >
                    <div className={clsx({ [classes.headerContainer]: true, [classes.preferenceHeader]: headerText === 'Preferences' })} >
                        <div className="rowFlex" style={{ justifyContent: 'center', width: '100%' }}>
                            {!showSearchOnly ? <ReactSVG id="acBack" className={classes.back} onClick={(event) => this.goBack()} src={Images.back} /> : null}
                            <div className={classes.header}>
                                {headerText ? headerText : customHeaderText}&nbsp; {headerText === 'Chat' && this.props.chatStore.chatData ? '- #' + this.props.chatStore.chatData.sessionId && this.props.chatStore.chatData.sessionId : null}
                            </div>
                            <div></div>
                        </div>
                        {/*!showSearchOnly ? this.renderMinimiseAndClose() : null*/}
                    </div>
                    <CloseChatWarning open={this.state.showChatDialog} closeDialog={this.closeDialog} confirmCloseChat={this.confirmCloseChat} />
                </div>
            </div>
        )
    }

    render() {
        const { headerType } = this.props;
        return (
            headerType == 'home' ?
                this.renderHomeHeader()
                :
                this.renderCommonHeader()
        )
    }
}

Header.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(headerStyles)(Header));
